import React, { useState } from 'react';
import logo from '../images/inspector-dottie-welcome.png';
import { TextField, Button } from '@material-ui/core';
import styles from './scss/Login.module.scss';
import { useTranslation } from 'react-i18next';
import { Link, withRouter, useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup"
import { useSnacks } from "../Util/Snacks";

/**
 * A simple login form.
 *
 * Accepts email address and password and asks the server if they match an account
 */
function Login() {
	const { t } = useTranslation();
	const history = useHistory();
	const [ disabled,setDisabled ] = useState(false);
	const { showError } = useSnacks();

	/* "Yup" handles validation via handy-dandy chainable mini-functions */
	const Validate=yup.object().shape({
		email: yup
			.string().trim()
			.email(t('NotEmail','Invalid email address'))
			.required(t('EmailRequired','Your email address is required')),
		password: yup
			.string()
			.required(t('PwdRequired','Your password is required'))
	});

	/* Form must have defaults -- even blanks -- or else react-hook-form will complain. */
	const Defaults={
		email:'',
		password:''
	};

	const { handleSubmit, control, errors } = useForm({
		defaultValues: Defaults,
		validationSchema: Validate
	});

	const onSubmitSuccess=(result)=>{
		result.json().then(
			(payload)=>{
				if(!!payload.success) {
					navigator.serviceWorker.ready.then(registration => {
						registration.active.postMessage({
							jwt:payload.token,
							refresh_token:payload.refresh_token,
							last_refresh:(new Date()).getTime()
						});
					});
					history.push("/Dashboard");
				} else {
					alert(payload.reason);
				}
			},
			(err)=> {
				result.text().then((text)=>{
					var arr,reason=t('LoginBomb','There was an error logging in on the server. No more information is available.');
					arr=/<\/h1>([\s\S]+)<\/article>/m.exec(text);
					if(arr && (arr.length > 1)) {
						reason=arr[1];
					} else {
						arr=/<title>([\s\S]+)<\/title>/m.exec(text);
						if(arr && (arr.length > 1)) {
							reason=arr[1];
						}
					}
					alert(reason);
				})
			}
		);
	};

	const onSubmitFailure=(result)=>{
		setDisabled(false);
		showError(t('Bad username or password'));
	};

	const onNetworkSuccess=(result)=>{
		if(result.ok) {
			onSubmitSuccess(result);
		} else {
			onSubmitFailure(result);
		}
	};

	const onNetworkFailure=(err)=>{
		setDisabled(false);
		showError(t('Could not make a network connection'));
	};

	/**
	 * Receives submitted data
	 *
	 * Note that fetch only fails on network error
	 */
	const onSubmit=(data)=>{
		setDisabled(true);
		fetch('/unauth/login',{
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json;charset=UTF-8'
			},
			body: JSON.stringify(data)
		}).then(
			onNetworkSuccess,
			onNetworkFailure
		);
	};

	const onJoin=(evt)=>{
		history.push("/Sign-Up");
	}

	return (
		<div className={styles.LoginPage}>
			<img src={logo} alt="Inspector Dottie" width="80" height="80" />
			<div className="LoginContainer">
				<div className="LoginJoin">
					<div className="Join">
						<h2>{t('New to Dottie?')}</h2>
						<h3>{t('Join our mission to create safe pools')}</h3>
						<Button type="button" onClick={onJoin}>{t('Join for Free')}</Button>
					</div>

					<form className="Login" onSubmit={handleSubmit(onSubmit)}>
						<h2>{t('Hi, kindly sign in')}</h2>
						<Controller
							as={TextField}
							InputLabelProps={{ shrink: true }}
							placeholder="email@example.com"
							name="email"
							label={t('Email','Email')}
							disabled={disabled}
							error={errors.email}
							control={control}
							variant="filled"
						/>
						{errors.email && <div className="FormError">{ errors.email.message }</div>}

						<Controller
							type="password"
							as={TextField}
							InputLabelProps={{ shrink: true }}
							placeholder={t('Password','Password')}
							disabled={disabled}
							name="password"
							label={t('Password','Password')}
							error={errors.password}
							control={control}
							autoComplete="current-password"
							variant="filled"
						/>
						{errors.password && <div className="FormError">{ errors.password.message }</div>}

						<Link to="/Forgot-Password" className="ForgotPwd"><span>{t('ForgotPwd','Forgot password?')}</span></Link>

						<Button type="submit" disabled={disabled}>{t('SignIn','Sign in')}</Button>
					</form>
				</div>
			</div>
		</div>
	);
}

export default withRouter(Login);
